import React from 'react';
import Loader from '../../cruxComponents/Loader';


export default function GetNewUID() {
  return <Loader />
}
